import type { Transition } from 'motion/react';

export interface ComposerMotion {
  toolbarAction: Transition;
  compactLayout: Transition;
  compactInlineControlExit: Transition;
  compactInlineControlEnter: Transition;
  compactToolbarShell: Transition;
  compactToolbarContent: Transition;
  compactToolbarContentExit: Transition;
  addMenuSlide: Transition;
  sourcesFade: Transition;
}

const STILL: Transition = { duration: 0 };

// DS `ease-out-quart` curve; the guide prefers it over the generic `easeOut`.
const EASE_OUT_QUART: [number, number, number, number] = [0.165, 0.84, 0.44, 1];

export const composerMotion = (shouldReduceMotion: boolean | null): ComposerMotion => {
  if (shouldReduceMotion) {
    return {
      toolbarAction: STILL,
      compactLayout: STILL,
      compactInlineControlExit: STILL,
      compactInlineControlEnter: STILL,
      compactToolbarShell: STILL,
      compactToolbarContent: STILL,
      compactToolbarContentExit: STILL,
      addMenuSlide: STILL,
      sourcesFade: STILL,
    };
  }
  const compactLayout: Transition = {
    type: 'spring',
    stiffness: 300,
    damping: 32,
    mass: 0.8,
  };
  return {
    toolbarAction: { type: 'spring', stiffness: 520, damping: 34, mass: 0.65 },
    compactLayout,
    compactInlineControlExit: {
      layout: compactLayout,
      opacity: { duration: 0.12, ease: EASE_OUT_QUART },
      scale: { duration: 0.12, ease: EASE_OUT_QUART },
    },
    compactInlineControlEnter: {
      layout: compactLayout,
      opacity: { duration: 0.15, ease: EASE_OUT_QUART, delay: 0.08 },
      scale: { duration: 0.15, ease: EASE_OUT_QUART, delay: 0.08 },
    },
    compactToolbarShell: {
      height: compactLayout,
      marginTop: compactLayout,
      opacity: { duration: 0.2, ease: EASE_OUT_QUART },
    },
    // The toolbar sits unclipped under the rising text line, so it fades in
    // once the line has cleared it and out before the line settles back.
    compactToolbarContent: {
      scale: compactLayout,
      opacity: { duration: 0.15, ease: EASE_OUT_QUART, delay: 0.13 },
    },
    compactToolbarContentExit: {
      scale: compactLayout,
      opacity: { duration: 0.08, ease: EASE_OUT_QUART },
    },
    // Reuse the card's expand spring so the shared-element controls move in lockstep.
    addMenuSlide: { layout: compactLayout },
    // Matches the toolbar content fade, so the two Sources copies cross in step.
    sourcesFade: { duration: 0.18, ease: EASE_OUT_QUART },
  };
};
